import { rankedSearch } from "@/lib/search";
// دليل الشهادات والمؤهلات: مرجع المتطلبات (ليس سجل ما تملكه) — بحث وتصفية بسيطة + «المتطلبات والتفاصيل» + «مهتم» + «لدي هذه الشهادة»
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { GlassCard, Skeleton } from "@/v2/components/ui";
import { GuideCard } from "@/masar/components/Cards";
import { CertDetails, useInterest } from "@/masar/components/CertDetails";
import { CertForm } from "@/masar/pages/Certificates";
import { BookOpen, Search, BadgeCheck } from "lucide-react";

const FILTERS = [["all", "الكل"], ["professional", "احترافية"], ["academic", "تعليمية"]];

export default function MasarCertGuide() {
  const navigate = useNavigate();
  const toggle = useInterest();
  const { data, isLoading } = useQuery({ queryKey: ["masar-cert-guide"], queryFn: async () => (await api.get("/masar/certificates/guide")).data });
  const [filters, setFilters] = useState(false);
  const [q, setQ] = useState(""); const [f, setF] = useState("all"); const [open, setOpen] = useState(null); const [form, setForm] = useState(null);
  const mine = useMemo(() => (data?.items || []).filter((x) => x.for_me), [data]);
  const shown = rankedSearch(mine.filter(x => f === "all" || x.kind === f), q, x => [x.name, x.abbreviation, x.issuer]);
  if (isLoading) return <Skeleton className="h-64 w-full" />;

  return (
    <div className="space-y-5" data-testid="masar-cert-guide">
      <GlassCard gold className="p-6 sm:p-8 v2-pattern relative overflow-hidden">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <div className="text-xs text-beige-ink mb-1">ما تحتاجه وما يرتبط بمسارك</div>
            <div className="flex items-center gap-3 mb-1"><BookOpen className="text-beige-ink" /><h1 className="text-2xl sm:text-3xl font-extrabold">دليل الشهادات</h1></div>
            <p className="text-sm text-ink-2">{data?.profile_title ? `${data.profile_title} — ` : ""}شهادات ومؤهلات مختارة لتخصصك وعملك الحالي في إدارتك.</p>
          </div>
        </div>
      </GlassCard>
      <div className="flex flex-wrap items-center gap-2">
        <div className="v2-inset flex items-center gap-2 px-3 h-10 flex-1 min-w-[220px]"><Search size={15} className="text-ink-2" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث باسم الشهادة أو المؤهل…" className="bg-transparent outline-none flex-1 text-sm" data-testid="guide-search" /></div>
        <button className="v2-btn-ghost v2-btn-sm" aria-expanded={filters} onClick={() => setFilters(!filters)}>تصفية{f !== "all" ? " (1)" : ""}</button>
        {filters && <div className="flex gap-1 flex-wrap basis-full" data-testid="guide-filters">{FILTERS.map(([k, l]) => <button key={k} onClick={() => setF(k)} data-testid={`guide-filter-${k}`} className={`v2-btn-sm ${f === k ? "v2-btn" : "v2-btn-ghost"}`}>{l}</button>)}</div>}
      </div>

      {shown.length === 0 ? (
        <GlassCard className="p-10 text-center" data-testid="guide-empty"><div className="font-bold mb-1">لا عناصر مطابقة</div><p className="text-sm text-ink-2">{data?.items?.length ? "غيّر التصفية أو كلمة البحث." : "لم تُنشر شهادات أو مؤهلات لمسارك بعد."}</p></GlassCard>
      ) : (
        <>
          {shown.length > 0 && <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="guide-mine">{shown.map((x) => <GuideCard key={x.id} x={x} onOpen={setOpen} onInterest={toggle} />)}</div>}

        </>
      )}
      {open && <CertDetails item={open} onClose={() => setOpen(null)} onHave={() => { setOpen(null); setForm({ requirement_id: open.id, name: open.name, issuer: open.issuer || "", kind: open.kind }); }} />}
      {form && <CertForm initial={form} onClose={() => setForm(null)} />}
    </div>
  );
}
